/*
 * Copyright (c) 2023-2025 Yesan SAS
 * All rights reserved
 *
 * The present software is the confidential and proprietary information of
 * Yesan SAS. You shall not disclose the present software and shall
 * use it only in accordance with the terms of the license agreement you
 * entered into with Yesan SAS. This software may be subject to
 * export or import laws in certain countries.
 */
/**
 * Translation
 */
export const translation = {
  "NotFound": "404 - Sayfa Bulunamadı",
  "ComingSoon": "Çok yakında",
  "YesanPersonalFinance": "Yesan, Kişisel Finans",
  "Yesan": "Yesan",
  "PersonalFinance": "Kişisel Finans",
  "YesanDownload": "Yesan İndir",
  "ThisWebsiteUsesCookies": "Site performansımız ve kullanımımız hakkında bilgi toplamak ve analiz etmek ve sosyal medya özellikleri sağlamak için çerezleri kullanıyoruz. Devam ederek, çerezleri kullanmamıza izin vermiş olursunuz.",
  "IGotIt": "TAMAM.",
  "BecomeFinanciallyFree": "Finansal Olarak Özgür Olun",
  "inStepsAndActions": "8 adımda ve 3 eylemde.",
  "TrackPlanAnalyze": "Takip et. Planla. Analiz et.",
  "FTrack": "1. İzleme",
  "FPlan": "2. Plan",
  "FAnalyze": "3. Analiz",
  "Features": "Özellikler",
  "FeaturesSubHeading": "Saf acemi, zaten finansal okuryazar, bu finansal olarak özgür olmak için ihtiyacınız olan uygulama.",
  "ManageAccounts": "Hesapları Yönet",
  "CashLiquidFixedAssetsLiabilities": "Nakit, Likit, Duran Varlıklar ve Yükümlülükler.",
  "TrackTransactions": "İşlemleri Takip Et",
  "IncomesExpensesTransferInvestments": "Gelirler, Giderler, Transferler, Yatırımlar.",
  "ImportExport": "İthalat / İhracat",
  "YourDataAlwaysAccessible": "Verileriniz her zaman erişilebilir.",
  "PlanYourFreedom": "Özgürlüğünüzü planlayın",
  "StepsAwayFromFI": "Finansal Bağımsızlıktan 8 adım ötede.",
  "BudgetsAndGoals": "Bütçeler & Hedefler",
  "CheckYourProgressAndAchieve": "İlerlemenizi kontrol edin ve finansal hedeflerinize ulaşın.",
  "DashboardAndAnalytics": "Gösterge Tablosu ve Analitik",
  "ReviewLearnOptimizeWith": "Grafikler, Analizler, Araçlar ile İnceleyin, Öğrenin, Optimize Edin.",
  "Security": "Güvenlik",
  "MilitaryGradeEncryption": "Askeri sınıf Şifreleme, Biyometri desteği, cihazlarınızda depolanan veriler.",
  "OfflineMode": "Çevrimdışı mod",
  "YourDataAlwaysAccessibleAndModif": "Verileriniz her zaman erişilebilir ve değiştirilebilir.",
  "Track": "Takip et",
  "Income": "Gelir",
  "Expense": "Giderler",
  "Transfer": "Transfer",
  "transactionsAndManageAccounts": "işlemler ve çeşitli Hesapları yönetmek:",
  "checkings": "Kontrol",
  "savings": "Tasarruf",
  "realEstate": "Gayrimenkul",
  "stocks": "Hisse senedi piyasaları",
  "bonds": "Tahviller",
  "crypto": "Kripto",
  "notes": "Notlar, Nakit Cüzdanı",
  "envelopes": "Zarflar",
  "privateEquity": "Özel Sermaye",
  "metal": "Metal",
  "retirement": "Emeklilik",
  "lifeInsurance": "Hayat Sigortası",
  "intellectualProperty": "Fikri Mülkiyet",
  "otherLiquidAsset": "Diğer Likit Varlıklar",
  "otherFixedAsset": "Diğer Duran Varlıklar",
  "mortgage": "Mortgage",
  "loan": "Tüketici Kredisi",
  "creditCard": "Kredi kartı",
  "otherLiability": "Diğer Yükümlülükler",
  "AccountsManagement": "Hesap yönetimi",
  "MultipleAccountsTypesAndGrouping": "Çoklu hesap türleri ve gruplama",
  "LinkAccounts": "Kurumlarınızdaki Hesapları Bağlayın (yalnızca belirli ülkelerde mevcuttur)",
  "SmartAccounts": "Akıllı hesaplar",
  "AddEditDeleteTransactions": "İşlem Ekleme / Düzenleme / Silme",
  "TickVerifiedTransactions": "Doğrulanmış işlemleri işaretleyin",
  "CategorizeTransactions": "İşlemleri kategorize edin",
  "TagTransactions": "Etiket işlemleri",
  "TrackKakeiboType": "Kakeibo tipini takip edin",
  "TrackInvestments": "Yatırımları Takip Et (yalnızca belirli ülkelerde mevcuttur)",
  "ImportFromCSVFile": "CSV dosyasından işlemlerin tamamını veya artımlı olarak içe aktarma",
  "ExportToCSVFile": "Transferi CSV dosyasına aktarma",
  "stepsTowardsFIPlanBudgetingReachGoals": "8 adımda Finansal Bağımsızlık planı, detaylı bütçeleme, finansal hedeflerinize daha hızlı ulaşın.",
  "levelsTowardsFI": "Finansal Bağımsızlığa Doğru 8 Seviye",
  "EstablishBudgetsPer": "Başına Bütçe Oluşturun",
  "account": "hesap",
  "accountType": "hesap türü",
  "KakeiboType": "Kakeibo tipi",
  "category": "Kategori",
  "tag": "etiket",
  "label": "etiket",
  "TrackBudgetsPerFrequency": "Frekans başına bütçeleri takip edin",
  "CreateGoalsOnSpendingBalanceCashFlowActions": "Harcama, denge, nakit akışı, eylemler üzerine Hedefler oluşturun",
  "TrackGoalsProgress": "Hedeflerin ilerlemesini takip edin",
  "ReviewLearnOptimizeWithReportsCharts": "Raporlar, Grafikler, Trendler, İçgörüler, Araçlar ile İnceleyin, Öğrenin, Optimize Edin.",
  "Dashboard": "Gösterge Tablosu",
  "FSNetWorth": "Finansal Tablolar: Net Değer",
  "FSPnL": "Finansal Tablolar: Gelir Tablosu / Kar ve Zarar",
  "FSBalanceSheetAssetsLiabilities": "Finansal Tablolar: Bilanço, Varlıklar, Yükümlülükler",
  "FSCashFlow": "Finansal Tablolar: Nakit Akış Tablosu, Borç Alacak, Akışlar",
  "FSFlows": "Finansal Tablolar: Akışlar",
  "FSRatios": "Finansal Tablolar: Oranlar",
  "TrendsMonthEnd": "Ay Sonu trendleri: Gelirler & Giderler, Nakit Akışı",
  "TrendsPerformance": "Performans trendleri: YoY, MoM, WoW",
  "IncomeTrendsPer": "Kişi başına gelir eğilimleri",
  "SpendingTrendsPer": "Kişi başına harcama eğilimleri",
  "RecurringItemsIE": "Yinelenen kalemler: Gelirler ve Giderler",
  "DebtProgressTrends": "Borç İlerleme eğilimleri",
  "KakeiboMTDReviewTrends": "Kakeibo: MTD incelemesi, geçen ay, trendler",
  "FIWCLE": "Finansal Bağımsızlık: Duvar Tablosu, Yaşam Enerjisine Göre Giderler",
  "DebtPaydownSnowballAvalanche": "Borç Ödeme: Kartopu, Çığ",
  "FullyCustomizableAnalyticsRange": "Tamamen özelleştirilebilir analiz zaman aralığı",
  "ContactUs": "Bize ulaşın",
  "Privacy": "Gizlilik",
  "Terms": "Şartlar",
  "About": "Hakkında",
  "IAgreeToThe": "Kabul ediyorum",
  "AndThe": "ve",
  "PrivacyPolicy": "Gizlilik Politikası",
  "TermsOfUse": "Kullanım Koşulları",

  "DigitalSoftwareExperienceTagline": "Modern dünya için dijital yazılım deneyimi",
  "DigitalExperience": "Dijital Deneyim",
  "SoftwareForTheModernWorld": "Modern dünya için yazılım",
  "MobileApplications": "Mobil Uygulamalar",
  "forConnectedAndOfflineHumans": "bağlı ve çevrimdışı insanlar için",
  "CloudSaaS": "Bulut SaaS",
  "ResponsiveAndWebServices": "Responsive ve Web hizmetleri",
  "PersonalFinanceServices": "Kişisel Finans Hizmetleri",
  "YS_p1": "Yesan, tüketiciler için özel olarak tasarlanmış son teknoloji mobil uygulamaların geliştirilmesinde uzmanlaşmış dinamik bir yazılım şirketidir. Günümüzün teknoloji meraklısı kullanıcılarının gelişen ihtiyaçlarını ve tercihlerini çok iyi anlayan Yesan, kullanıcılarının hayatlarını zenginleştiren sezgisel, ilgi çekici ve zengin özelliklere sahip mobil deneyimler oluşturmaya kendini adamıştır.",
  "YS_p2": "Yesan'ın misyonunun özünde, inovasyon ve yaratıcılığa olan amansız bağlılık yatmaktadır; her ürün kusursuz işlevsellik ve olağanüstü bir kullanıcı deneyimi sunmak için titizlikle hazırlanmıştır.",
  "PersonalFinanceApplication": "Kişisel Finans Uygulaması",
  "YPF_p1": "Yesan, Kişisel Finans, kullanıcıları parmaklarının ucunda kolayca erişilebilen kapsamlı finansal yönetim araçlarıyla güçlendirmek için tasarlanmış son teknoloji bir kişisel finans mobil uygulamasıdır. Şık ve sezgisel bir arayüze sahip olan Yesan, Personal Finance, her düzeyde finansal okuryazarlığa sahip kullanıcılara hitap ederek finans yönetimi için bütünsel bir yaklaşım sunar.",
  "YPF_p2": "Temel özellikler arasında bütçe takibi, gider kategorizasyonu ve gerçek zamanlı işlem izleme yer alıyor ve kullanıcıların harcama alışkanlıkları hakkında zahmetsizce bilgi edinmelerini sağlıyor. Uygulama ayrıca özelleştirilebilir bütçeleme seçenekleri sunarak kullanıcıların finansal hedefler belirlemelerine ve zaman içindeki ilerlemelerini takip etmelerine olanak tanıyor.",
  "YPF_p3": "Dahası, Yesan, Personal Finance, kullanıcıların hassas finansal bilgilerini korumak için en gelişmiş şifreleme protokollerini kullanarak güvenliğe öncelik verir. Banka düzeyinde güvenlik önlemleri ile kullanıcılar, gizlilikten ödün vermeden hesaplarını güvenle bağlayabilir ve işlemleri senkronize edebilirler.",
  "YPF_p4": "Yesan, Personal Finance, finansal kararları optimize etmek için anlayışlı analizler ve kişiselleştirilmiş öneriler sunarak temel bütçelemenin ötesine geçer. İster potansiyel tasarruf fırsatlarını belirlemek, ister yatırım portföylerini izlemek veya borç geri ödeme stratejilerini yönetmek olsun, uygulama, kullanıcıların finansal hedeflerine ulaşmalarına yardımcı olmak için özel bilgiler sağlar.",
  "Discover": "Keşfedin",
  "Firstname": "İlk isim",
  "Lastname": "Soyadı",
  "Company":"Şirket",
  "Subject": "Konu",
  "Email": "E-posta",
  "Message": "Mesaj",
  "ThankYouForContactingUs": "Bizimle iletişime geçtiğiniz için teşekkür ederiz",
  "ValidFirstnameRequired": "Geçerli ilk ad gereklidir.",
  "ValidLastnameRequired": "Geçerli soyadı gereklidir.",
  "ValidEmailAddressRequired": "Lütfen geçerli bir e-posta adresi girin.",
  "ValidSubjectRequired": "Lütfen geçerli bir konu seçin.",
  "ValidMessageRequired": "Lütfen geçerli bir mesaj girin.",
  "UnableToSendTheFormPleaseRetryLater": "Form gönderilemiyor lütfen daha sonra tekrar deneyin.",
  "Information": "Bilgi",
  "Sales":"Satış",
  "Support": "Destek",
  "Press": "Basın",
  "Partnership": "Ortaklık",
  "Other": "Diğer",
  "Blog":"Blog",

  "Accept":"Kabul et",
  "Decline":"Düşüş",

  "WorklogCalendar":"Jira için İş Günlüğü Takvimi",

  "DirectlyAccessibleInProjectApps":"Proje uygulamalarından doğrudan erişilebilir",
  "VisualizeWhereYouSpentYourTime":"Zamanınızı nerede geçirdiğinizi görselleştirin",
  "AllYourWorklogsInACalendar":"Tüm iş günlükleriniz bir takvimde",
  "MonthSummary":"Ay özeti",
  "CheckIfYouForgotToLogTime":"Zamanı kaydetmeyi unutup unutmadığınızı kontrol edin.",
  "DirectlyAccessTheIssuesAndUpdateTime":"Sorunlara ve güncelleme zamanına doğrudan erişim",
  "DirectlyAccessTheIssuesAndUpdateTimeDescription":"Sorunlara doğrudan erişmek ve izlenen zamanınızı düzenlemek için iş günlüğü öğesine tıklayın",
  "AlsoAvailableInDarkMode":"Karanlık modda da mevcuttur",
  "DirectlyLogWorkOnTheCalendarVisually":"Çalışmayı doğrudan takvime görsel olarak kaydedin",
  "ClickOnTheCalendarToCreateNewWorklog":"Yeni iş günlüğü oluşturmak için takvime tıklayın",

  "AppsForAtlassian":"Atlassian için Uygulamalar",
  "YCL_p1":"Tüm iş günlüklerinizi ay, hafta, çalışma haftası, gün görünümleriyle bir takvim üzerinde görselleştirin.",
  "YCL_p2":"Zaman aralığını görsel olarak seçerek doğrudan takvimden iş kaydı yapın.",
  "YCL_p3":"Zaman çizelgeleriniz için zamanı izlemeyi unutup unutmadığınızı belirleyin.",
  "YCL_p4":"Kendi dilinizde kullanılabilir: İngilizce (İngiltere), İngilizce (ABD), Çince (Basitleştirilmiş), Çince (Geleneksel), Çekçe, Danca, Felemenkçe, Estonca, Fince, Fransızca, Almanca, Macarca, İzlandaca, İtalyanca, Japonca, Korece, Norveççe, Lehçe, Portekizce (Brezilya), Portekizce (Portekiz), Rusça, İspanyolca, İsveççe, Türkçe.",

  "Kakeibo":"Kakeibo",
  "Genea":"Genea",
  "FinancialPortfolio":"Jira için Finansal Portföy",
  "BringRealFinancialPortfolio":"Jira'ya gerçek finansal portföy yönetimi getirin. Bütçeleri, CapEx/OpEx ve proje maliyetlerini tek bir yerden takip edin.",
  "YFPAboutQ":"Jira projelerimiz bize gerçekte ne kadara mal oluyor?",
  "YFPAbout":"Jira için Finansal Portföy\nFinans liderleri ve PMO'lar basit bir soruyu yanıtlamakta zorlanıyor:\nJira projelerimiz bize gerçekte ne kadara mal oluyor?\nJira işleri takip eder.\nFinans bütçeleri takip eder.\nBu uygulama nihayet ikisini birbirine bağlar.\n\nFinancial Portfolio, pahalı kurumsal araçlara ihtiyaç duymadan Jira'yı hafif bir PPM + Finansal planlama platformuna dönüştürür.",
  "YFPPorfolioQ":"Portföy Bütçeleri ve Takibi",
  "YFPPorfolioP":"Birden fazla Jira projesinde portföyler oluşturun ve şunları tanımlayın: Bütçe tutarı, Para birimi, Tarih aralığı, Dahil edilen projeler, ekipler. Jira'da işler ilerledikçe gerçek maliyetleri otomatik olarak takip edin.",
  "YFPPorfolioListQ":"Portföyler",
  "YFPPorfolioListP":"Birden fazla Jira projesini birleştiren finansal portföyler oluşturun ve anında şunları görün: Bütçe ile Gerçek maliyet karşılaştırması, Gerçek zamanlı proje harcama oranı, CapEx ile OpEx dağılımı, Sorun ve proje başına maliyet, Dışa aktarılabilir finansal raporlar. Hepsi doğrudan Jira iş günlükleri tarafından desteklenir.",
  "CostQ":"Otomatik Maliyet Hesaplama",
  "CostP":"Zaman takibini gerçek finansal verilere dönüştürün. Uygulama: Jira iş günlüklerini okur, saatlik ücretleri uygular, gerçek proje maliyetlerini günlük olarak hesaplar. Excel tabloları yok. Manuel iş yok.",
  "RatesQ":"Ücretler",
  "RatesP":"Proje, ekip ve genel olarak saatlik ücretleri belirleyin",
  "ReportQ":"CSV Finansal Raporlama",
  "ReportP":"Portföy finansal verilerini saniyeler içinde dışa aktarın. Şunlar için mükemmel: Finans ekipleri, CFO raporlaması, Bütçe planlaması, Denetim desteği",
  "SettingsQ":"CapEx ve OpEx Sınıflandırması",
  "SettingsP":"Muhasebe ve denetim gereksinimlerini destekleyin. İşleri şu şekilde sınıflandırın: Aktifleştirilebilir geliştirme (CapEx), Operasyonel iş (OpEx). Finans ekipleri için hazır, dışa aktarılabilir raporlar oluşturun."
};

export const documents = {
};
